import Vue from 'vue'
import debounce from 'vue-debounce'

Vue.use(debounce)
